import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const services = [
  {
    name: 'Luxury Nails',
    desc: 'Gel sets, acrylic full sets, fills, intricate designs, and our patent-pending 3D AI nail art printer — 3,400 DPI, every visit.',
    icon: '💅',
    testid: 'nails',
    tag: null,
  },
  {
    name: 'Spray Tans',
    desc: 'Custom-blended luxury spray tans, contoured to your body. 100% vegan & cruelty-free solution. The OG service that started 24K Glow On The Go.',
    icon: '✨',
    testid: 'spray-tan',
    tag: '🌿 VEGAN · CRUELTY-FREE',
  },
  {
    name: 'Facials',
    desc: 'Signature glow facials, hydrating treatments, and personalized skin care performed by a licensed esthetician.',
    icon: '🪞',
    testid: 'facials',
    tag: null,
  },
  {
    name: 'UV Blue Light Therapy',
    desc: 'Soothing UV blue light treatment to help combat blemishes, brighten skin, and accelerate healing — a luxe add-on for any facial.',
    icon: '💎',
    testid: 'uv-blue-light',
    tag: 'NEW',
  },
  {
    name: 'Pro Makeup',
    desc: 'Professional makeup for weddings, events, photoshoots, date nights, or anytime you want to feel like a goddess.',
    icon: '💋',
    testid: 'makeup',
    tag: null,
  },
  {
    name: 'Hair Styling',
    desc: 'Blowouts, event hair, and styling that completes your look — without leaving your home.',
    icon: '💇‍♀️',
    testid: 'hair',
    tag: null,
  },
  {
    name: 'AI 3D Nail Art',
    desc: 'Bring any image, photo, or idea — our patent-pending 3,400 DPI nail printer brings it to life on your fingertips.',
    icon: '🖨️',
    testid: 'ai-art',
    tag: null,
  },
];

const Services = () => {
  return (
    <div className="py-20" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-4">✦ Services ✦</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-amber-50" data-testid="services-title">
            Everything you need to <span className="italic text-pink-300">glow</span>
          </h1>
          <p className="mt-4 text-amber-100/60 max-w-2xl mx-auto">
            One luxury mobile salon. Every service. Brought to your door across Northeast FL & Southern GA.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map(s => (
            <Link
              key={s.name}
              to={`/book?service=${encodeURIComponent(s.name)}`}
              className="group rounded-2xl bg-[#0a0405] border border-amber-900/30 p-8 hover:border-pink-400/60 hover:-translate-y-1 transition-all block cursor-pointer"
              data-testid={`service-${s.testid}`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="text-4xl" aria-hidden="true">{s.icon}</div>
                {s.tag && (
                  <span className="text-[9px] tracking-[0.2em] uppercase bg-pink-300/20 text-amber-200 px-2 py-1 rounded-full border border-amber-700/50">
                    {s.tag}
                  </span>
                )}
              </div>
              <h3 className="font-serif text-2xl text-amber-100">{s.name}</h3>
              <p className="mt-3 text-sm text-amber-100/70 leading-relaxed">{s.desc}</p>
              <div className="mt-5 flex items-center gap-2 text-pink-300 text-sm font-medium">
                Book this service
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-16">
          <Link to="/book" className="inline-block px-10 py-4 rounded-full bg-pink-300 text-black font-medium hover:bg-pink-200 transition-all" data-testid="services-cta">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Services;
